var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _vm.checkPermi(["merchant:product:page:list"])
        ? _c(
            "el-card",
            {
              staticClass: "ivu-mt",
              attrs: {
                bordered: false,
                shadow: "never",
                "body-style": { padding: 0 },
              },
            },
            [
              _c(
                "div",
                { staticClass: "padding-add" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: "",
                        size: "small",
                        "label-position": "right",
                      },
                      nativeOn: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "房间类型" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                clearable: "",
                                size: "small",
                                placeholder: "请选择房间类型",
                              },
                              on: { change: _vm.handleSeachList },
                              model: {
                                value: _vm.tableFrom.roomTypeId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.tableFrom, "roomTypeId", $$v)
                                },
                                expression: "tableFrom.roomTypeId",
                              },
                            },
                            _vm._l(_vm.roomTypeList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.roomTypeName,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "房间状态: " } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                clearable: "",
                                size: "small",
                                placeholder: "请选择",
                              },
                              on: { change: _vm.handleSeachList },
                              model: {
                                value: _vm.tableFrom.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.tableFrom, "status", $$v)
                                },
                                expression: "tableFrom.status",
                              },
                            },
                            _vm._l(_vm.roomStatusList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "small" },
                              on: { click: _vm.handleSeachList },
                            },
                            [_vm._v("查询")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: { click: _vm.handleReset },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "0 20px 20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c(
            "div",
            { staticClass: "room-container" },
            _vm._l(_vm.tableData.data, function (room) {
              return _c(
                "div",
                {
                  key: room.id,
                  class: [room.statusClass, "room-card"],
                  on: {
                    click: function ($event) {
                      return _vm.showRoomDialog(room)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "room-header" },
                    [
                      _c("div", { staticClass: "room-number" }, [
                        _vm._v(_vm._s(room.number)),
                      ]),
                      _c("el-tag", { attrs: { size: "mini", type: "info" } }, [
                        _vm._v("干净房"),
                      ]),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "room-header" }, [
                    _c("div", { staticClass: "room-type" }, [
                      _vm._v(_vm._s(room.type)),
                    ]),
                    room.status == 1
                      ? _c("span", { staticClass: "room-available" }, [
                          _vm._v("空闲房"),
                        ])
                      : _c("span", { staticClass: "room-use" }, [
                          _vm._v(" 入住中"),
                        ]),
                  ]),
                ]
              )
            }),
            0
          ),
        ]
      ),
      _c(
        "el-drawer",
        {
          staticClass: "showHeader",
          attrs: {
            title: !_vm.stockEdit ? "免审编辑" : "编辑库存",
            visible: _vm.drawer,
            direction: _vm.direction,
            size: 1500,
            "before-close": _vm.handleCloseEdit,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _vm.drawer && _vm.productId
            ? _c("store-edit", {
                attrs: {
                  productId: _vm.productId,
                  productType: _vm.productType,
                  stockEdit: _vm.stockEdit,
                  isSub: _vm.isSub,
                },
                on: { subSuccess: _vm.subSuccess },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-top",
          attrs: {
            visible: _vm.dialogVisible,
            title: "设置运费",
            "destroy-on-close": "",
            "close-on-click-modal": false,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formValidate",
              staticClass: "formValidate",
              attrs: {
                rules: _vm.ruleValidate,
                model: _vm.formValidate,
                "label-width": "75px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "运费模板：", prop: "tempId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "mr20",
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.formValidate.tempId,
                        callback: function ($$v) {
                          _vm.$set(_vm.formValidate, "tempId", $$v)
                        },
                        expression: "formValidate.tempId",
                      },
                    },
                    _vm._l(_vm.shippingTemplates, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c("el-form-item", [
                _c(
                  "div",
                  { staticClass: "dialog-footer-inner" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "btns",
                        attrs: { size: "small" },
                        on: { click: _vm.handleClose },
                      },
                      [_vm._v("取消")]
                    ),
                    _vm.checkPermi(["merchant:product:update"])
                      ? _c(
                          "el-button",
                          {
                            staticClass: "submission",
                            attrs: { type: "primary", loading: _vm.loadingBtn },
                            on: {
                              click: function ($event) {
                                return _vm.handleSubmit("formValidate")
                              },
                            },
                          },
                          [_vm._v("确定")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm.dialogCommision
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "设置佣金",
                visible: _vm.dialogCommision,
                width: "600px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogCommision = $event
                },
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "commisionForm",
                  attrs: { model: _vm.commisionForm, rules: _vm.commisionRule },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "一级佣金比例：", prop: "extension_one" },
                    },
                    [
                      _c("el-input-number", {
                        staticClass: "priceBox",
                        attrs: {
                          step: 1,
                          "step-strictly": "",
                          min: 0,
                          max: 100,
                          "controls-position": "right",
                        },
                        model: {
                          value: _vm.commisionForm.brokerage,
                          callback: function ($$v) {
                            _vm.$set(_vm.commisionForm, "brokerage", $$v)
                          },
                          expression: "commisionForm.brokerage",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "二级佣金比例：", prop: "extension_two" },
                    },
                    [
                      _c("el-input-number", {
                        staticClass: "priceBox",
                        attrs: {
                          step: 1,
                          min: 0,
                          "step-strictly": "",
                          max: 100,
                          "controls-position": "right",
                        },
                        model: {
                          value: _vm.commisionForm.brokerageTwo,
                          callback: function ($$v) {
                            _vm.$set(_vm.commisionForm, "brokerageTwo", $$v)
                          },
                          expression: "commisionForm.brokerageTwo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c("span", [
                      _vm._v(
                        "备注：订单交易成功后给推广员返佣的比例，例:一级佣金比例设置5，则返订单金额的5%"
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.dialogCommision = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitCommisionForm("commisionForm")
                        },
                      },
                    },
                    [_vm._v("提交")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("product-tpye", {
        ref: "productTpye",
        attrs: { addType: _vm.addType },
      }),
      _vm.roomDialogVisible
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "经营弹窗",
                visible: _vm.roomDialogVisible,
                width: "600px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.roomDialogVisible = $event
                },
                close: _vm.handleRoomDialogClose,
              },
            },
            [
              _vm.selectedRoom.status === 1
                ? _c(
                    "div",
                    [
                      _c("p", [
                        _vm._v("房间号: " + _vm._s(_vm.selectedRoom.number)),
                      ]),
                      _c(
                        "p",
                        [
                          _vm._v("当前状态: "),
                          _c("el-tag", { attrs: { type: "success" } }, [
                            _vm._v("空闲房"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.showReservationDialog },
                        },
                        [_vm._v(" 选择预约记录 ")]
                      ),
                      _vm.selectedReservation
                        ? _c("div", { staticClass: "reservation-info" }, [
                            _c("h4", [_vm._v("已选预约信息:")]),
                            _c("p", [
                              _vm._v(
                                "预约人: " +
                                  _vm._s(_vm.selectedReservation.customerName)
                              ),
                            ]),
                            _c("p", [
                              _vm._v(
                                "选择房型: " +
                                  _vm._s(_vm.selectedReservation.roomTypeId)
                              ),
                            ]),
                            _c("p", [
                              _vm._v(
                                "联系电话: " +
                                  _vm._s(_vm.selectedReservation.customerMobile)
                              ),
                            ]),
                            _c("p", [
                              _vm._v(
                                "入住日期: " +
                                  _vm._s(
                                    _vm.selectedReservation.reservationStartDate
                                  )
                              ),
                            ]),
                            _c("p", [
                              _vm._v(
                                "离店日期: " +
                                  _vm._s(
                                    _vm.selectedReservation.reservationEndDate
                                  )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ],
                    1
                  )
                : _c("div", [
                    _c("p", [
                      _vm._v("房间号: " + _vm._s(_vm.selectedRoom.number)),
                    ]),
                    _c(
                      "p",
                      [
                        _vm._v("当前状态: "),
                        _c("el-tag", { attrs: { type: "warning" } }, [
                          _vm._v("入住中"),
                        ]),
                      ],
                      1
                    ),
                    _c("p", [_vm._v("确认安排离店？")]),
                  ]),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "div",
                    { staticClass: "dialog-footer" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled:
                              _vm.isCheckInDisabled || !_vm.selectedReservation,
                          },
                          on: { click: _vm.handleCheckIn },
                        },
                        [_vm._v(" 安排入住 ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "danger",
                            disabled: _vm.isCheckOutDisabled,
                          },
                          on: { click: _vm.handleCheckOut },
                        },
                        [_vm._v(" 安排离店 ")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择预约记录",
            visible: _vm.reservationDialogVisible,
            width: "70%",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.reservationDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.reservationList, border: "" },
              on: { "selection-change": _vm.handleReservationSelect },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { prop: "roomTypeId", label: "预约房型类型编号" },
              }),
              _c("el-table-column", {
                attrs: { prop: "customerName", label: "预约人", width: "120" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "customerMobile",
                  label: "联系电话",
                  width: "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "reservationStartDate",
                  label: "入住日期",
                  width: "180",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "reservationEndDate",
                  label: "离店日期",
                  width: "180",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "predictArrivalTime",
                  label: "预计到店时间",
                  width: "180",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "预约创建时间",
                  width: "180",
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.reservationDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: !_vm.tempSelectedReservation,
                  },
                  on: { click: _vm.confirmReservation },
                },
                [_vm._v(" 确定选择 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }